import React from 'react'
// import '../styles/footer.css'

const Footer = () => {
  return (
    <footer>
        <div className='left'>
            <h1>TechyStar</h1>
            <p>@all rigths reserved</p>
        </div>
        <div className='right'>
            <h5>Follow Us</h5>
            <a href="https://youtube.com" target='blank' >Youtube</a>
            <a href="https://instagram.com" target='blank' >Instagram</a>
            <a href="https://github.com" target='blank' >Github</a>
        </div>
    </footer>

    )
}

export default Footer